import { connect } from 'react-redux';

const NotFound = ({ config }) => {
  const html = { __html: config.notFoundContent };

  return (
    <div className="container content">
      <div className="row">
        {/* eslint-disable-next-line @eslint-react/dom-no-dangerously-set-innerhtml */}
        <div className="col-lg-12" dangerouslySetInnerHTML={html} />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  config: state.config,
});

export default connect(mapStateToProps)(NotFound);
